export const payByBankColors = {
  green90: '#004232',
  green20: '#C4E5DD',
  green10: '#E8F4EE',
  blue70: '#0555AE',
  blue40: '#3387E1',
  purple10: '#EADAF2',
  purple70: '#3C0059',
  purple100: '#1A0033',
  gray40: '#646d72',
};
